import request from '@utils/request'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  export({ commit }, exportParams) {
    return request.post('/admin/order/export', exportParams).then((response) => response.items)
  },
  simpleExport({ commit }, exportParams) {
    return request.post('/admin/order/export/simple', exportParams).then((response) => response.items)
  },
  verifyCodes({ commit }, storeData) {
    return request.post('/admin/qrcode/verify', {
      ids: [...storeData],
    })
  },
  verifyCode({ commit }, { codeId, verifyRule }) {
    return request.post(`admin/qrcode/${codeId}/verify`, verifyRule, {
      errorHandle: false,
    })
  },
  fetchSingleCode({ commit }, codeId) {
    return request
      .get(`admin/qrcode/${codeId}`, {
        errorHandle: false,
      })
      .then((response) => response.items)
  },

  verifySingleCode({ commit }, { codeId, orderId }) {
    return request.post(`/admin/qrcode/${codeId}/verify`, { orderId })
  },
  sendLink({ commit }, { orderId, router }) {
    return request.post(`admin/order/${orderId}/sendLink`, {
      router,
    })
  },
  sendContainerLink({ commit }, { uuid, router }) {
    return request.post(`admin/order/container/${uuid}/sendLink`, {
      router,
    })
  },
  getLink({ commit }, orderId) {
    return request.get(`admin/order/${orderId}/shortUrl`)
  },
  cancel({ commit }, { orderId, cancelData }) {
    // orderId, note, refundValue
    return request.post(`admin/order/${orderId}/cancel`, cancelData)
  },
  store({ commit }, storeData) {
    const { isSpecifyScheduleItem } = storeData

    if (typeof isSpecifyScheduleItem === 'undefined') {
      storeData.isSpecifyScheduleItem = 0
    }
    const errorData = {
      errorHandle: storeData.errorHandle || true,
      hideErrorMessage: !storeData.errorHandle || false,
    }
    return request.post('/admin/order/store', storeData, errorData)
  },
  fetchSingle({ commit }, orderId) {
    return request.get(`admin/order/${orderId}`).then((response) => response.items)
  },
  fetchList({ commit }, query) {
    return request.post('admin/order/search', query).then(({ items, productName, pagination: { total } }) => {
      return {
        items,
        productName,
        total,
      }
    })
  },
  fetchInventoryList({ commit }, query) {
    return request.post('admin/order/search', query).then(({ items, productName }) => {
      return {
        items,
        productName,
      }
    })
  },
  fetchAvailablePeriod({ commit }, submitData) {
    return request.post('/admin/schedule/calendar/search/availablePeriod', submitData)
  },
  storeModifyOrder({ commit }, storeData) {
    return request.post('/admin/order/changeTime', storeData)
  },
  fetchMerchantNote({ commit }, id) {
    return request.post('/admin/order/merchantNote', { id }).then(({ items: { contents } }) => contents)
  },
  storeMerchantNote({ commit }, { id, note }) {
    return request.post(`/admin/order/${id}/addMemberNote`, { note })
  },

  storeAdditionalOrder({ commit }, storeData) {
    return request.post('/admin/order/additional/store', storeData)
  },
  fetchSingleAdditional({ commit }, orderId) {
    return request.get(`/admin/order/additional/${orderId}`).then((response) => response.items)
  },
  fetchHelperList({ commit }, id) {
    return request.post('admin/order/searchHelpers', { orderId: id })
  },
  fetchServiceHelperList({ commit }, fetchData) {
    return request.post('admin/order/searchHelpers', fetchData)
  },
  storeAssignHelper({ commit }, storeData) {
    return request.post('admin/order/assignHelper', storeData)
  },
  refundOrder({ commit }, { id, refundData }) {
    return request.post(`admin/order/${id}/refund`, refundData)
  },
  storeOrderItem({ commit }, storeData) {
    return request.post(`admin/order/item/modify`, storeData)
  },
  /**
   * @description 刪除訂單
   */
  deleteOrderItem({ commit }, storeData) {
    return request.post(`admin/order/remove`, storeData)
  },
  /**
   * @description container 儲存 -> checkout
   */
  storeContainerId({ commit }, storeData) {
    return request.post(`admin/order/container/store`, storeData)
  },
  /**
   * @description 商品容器建立（v2；path uuid = container.uuid，建單+結帳一次完成）
   */
  createGoodsContainer({ commit }, { uuid, body }) {
    return request.post(`v2/admin/goods/container/${uuid}`, body, {
      errorHandle: false,
    })
  },
  /**
   * @description container 搜尋
   */
  orderContainerSearch({ commit }, searchData) {
    return request.post(`admin/order/container/search`, searchData)
  },
  /**
   * @description 獲取container內的所有訂單內容
   */
  fetchContainerList({ commit }, uuid) {
    return request.get(`admin/order/container/${uuid}`).then((response) => response.items)
  },
  /**
   * @description 取消container
   */
  containerCancel({ commit }, storeData) {
    const { uuid } = storeData
    return request.post(`admin/order/container/${uuid}/cancel`, storeData).then((response) => response.items)
  },
  installmentStore({ commit }, storeData) {
    return request.post(`admin/installment/store`, storeData)
  },
}
